import React from 'react'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import Divider from '@mui/material/Divider'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'

const TaskLine = ({ task, onClick }) => (
  <Box
    alignItems="center"
    padding={1}
    justifyContent="space-between"
    display="flex"
    component={Paper}
    sx={{cursor: 'pointer'}}
    onClick={onClick}
  >
    <Box display="flex" gap={1}>
      <Chip
        label={task.taskStatus}
        color={task.taskStatus === 'New' ? 'error' : task.taskStatus === 'In Progress' ? 'warning' : 'success'}
        size="small"
        sx={{ borderRadius: 1 }}
      />
      <Typography>{task.taskName}</Typography>
    </Box>
    <Box display="flex" gap={3}>
      <Box></Box>
      <KeyboardArrowRightIcon />
    </Box>
  </Box>
)

export default TaskLine
